import { createQuery } from 'react-query-kit';

import { fetchData } from 'services/http/http';
import portalSchema from 'support/types/schema-portal';

type SupplierPublicInfoResponse =
  portalSchema.paths['/v1/order-forms/{supplierSlugName}/supplier']['get']['responses']['200']['content']['application/json'];
export const useSupplierPublicInfo = createQuery<
  SupplierPublicInfoResponse,
  { supplierSlug: string | undefined },
  Error
>({
  primaryKey: '/order-forms/:supplierSlug/supplier',
  queryFn: async ({ queryKey: [, variables] }) => {
    const { data } = await fetchData<SupplierPublicInfoResponse>(`/v1/order-forms/${variables.supplierSlug}/supplier`);
    return data;
  },
  staleTime: 1000 * 60 * 60, // 1 hour
  enabled: (data, variables) => !!variables.supplierSlug,
});

export const ORDER_FORMS_QUERY_KEY = '/order-forms';

export type GetOrderFormResponse =
  portalSchema.paths['/v1/order-forms/{supplierSlugName}']['get']['responses']['200']['content']['application/json'];

export const useOrderForm = createQuery<GetOrderFormResponse, { supplierSlugName: string | undefined }, Error>({
  primaryKey: '/order-forms/:supplierSlugName',
  queryFn: async ({ queryKey: [, { supplierSlugName }] }) => {
    const { data } = await fetchData<GetOrderFormResponse>(`/v1/order-forms/${supplierSlugName}`);
    return data;
  },
  enabled: (_, { supplierSlugName }) => !!supplierSlugName,
});

export const useHasAccessToOrderForm = useOrderForm;
